/**
 * Styles for the CreateTicket form
 */

export const headerColor = 'action.hover';

export const headerStyle = {
  bgcolor: headerColor,
  color: 'text.primary',
  padding: '12px 20px',
  fontSize: '0.95rem',
  fontWeight: 600,
  letterSpacing: '0.2px',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  borderBottom: '1px solid',
  borderBottomColor: 'divider'
};

export const cardStyle = {
  marginBottom: '16px',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '10px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  overflow: 'hidden',
  backgroundColor: 'background.paper'
};

export const cardContentStyle = {
  padding: '20px'
};

export default { headerColor, headerStyle, cardStyle, cardContentStyle };
